// Generated by purs version 0.15.15
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_AmountCents from "../Ouroboros.Models.Brands.AmountCents/index.js";
import * as Ouroboros_Models_Brands_BillingPeriod from "../Ouroboros.Models.Brands.BillingPeriod/index.js";
import * as Ouroboros_Models_Brands_BillingProvider from "../Ouroboros.Models.Brands.BillingProvider/index.js";
import * as Ouroboros_Models_Brands_BillingProviderTransactionId from "../Ouroboros.Models.Brands.BillingProviderTransactionId/index.js";
import * as Ouroboros_Models_Brands_BillingTransactionState from "../Ouroboros.Models.Brands.BillingTransactionState/index.js";
import * as Ouroboros_Models_Brands_CardLast4 from "../Ouroboros.Models.Brands.CardLast4/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_PlanTier from "../Ouroboros.Models.Brands.PlanTier/index.js";
import * as Ouroboros_Models_Brands_RetryCount from "../Ouroboros.Models.Brands.RetryCount/index.js";
import * as Ouroboros_Models_Brands_SeatCount from "../Ouroboros.Models.Brands.SeatCount/index.js";
import * as Ouroboros_Models_Brands_UUID from "../Ouroboros.Models.Brands.UUID/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readMaybe = /* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp);
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var decodeAdminPlanResponse = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "activeAt";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "billingHistory";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "amountCents";
    }
})(Ouroboros_Models_Brands_AmountCents.readAmountCents)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "billedAt";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "cardLast4";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_CardLast4.readCardLast4))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Ouroboros_Models_Brands_UUID.readUUID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "nextRetryAt";
    }
})(readMaybe)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "provider";
    }
})(Ouroboros_Models_Brands_BillingProvider.readBillingProvider)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "providerTransactionId";
    }
})(Ouroboros_Models_Brands_BillingProviderTransactionId.readBillingProviderTransactionId)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "retryCount";
    }
})(Ouroboros_Models_Brands_RetryCount.readRetryCount)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "transactionState";
    }
})(Ouroboros_Models_Brands_BillingTransactionState.readBillingTransactionState)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()())()())()())))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "billingPeriod";
    }
})(Ouroboros_Models_Brands_BillingPeriod.readBillingPeriod)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "endAt";
    }
})(readMaybe)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "seatLimit";
    }
})(Ouroboros_Models_Brands_SeatCount.readSeatCount)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "tier";
    }
})(Ouroboros_Models_Brands_PlanTier.readPlanTier)(Simple_JSON.readFieldsNil)()())()())()())()())()())()()));
export {
    decodeAdminPlanResponse
};
//# sourceMappingURL=index.js.map
